function fn_part_form() {
    var fn = ".part_form",
        $fn = $(fn);

    if ($fn.length) {
        $(document).on("change", fn + " [data-toggle] input", function() {
            $(this).closest("[data-toggle]").next(".mod--row").slideToggle(300);
        });
    }
}